<div class="hero-dark"></div>
<div class="container">
  @if (travel_data?.gmg_finalizing) {
  <h1>Finalizza il tuo <span class="yellow">viaggio GMG</span></h1>
  } @else if (travel_id && travel_data?.funding === true) {
  <h1>Modifica <span class="yellow">viaggio GMG</span></h1>
  } @else if (travel_id) {
  <h1>Modifica <span class="yellow">viaggio</span></h1>
  } @else if (travel_data?.funding === true) {
  <h1>Crea un <span class="yellow">evento GMG</span></h1>
  } @else {
  <h1>Crea un nuovo <span class="yellow">viaggio</span></h1>
  }

  <div class="mt-6 card-container">
    <div class="grid">
      <div class="col-12 lg:col-3 xl:col-3 xl:pr-4">
        <div class="card-menu">
          <ul>
            <li [ngClass]="{ active: menuIndex === 0 }" (click)="goTo(0)">
              <div class="flex align-items-center gap-1">
                <i class="link-o pi pi-info-circle"></i>
                <span class="link-o">Informazioni di base</span>
                @if (
                form_section_validation.get("section_0")?.valid === false
                ) {
                <div class="alert-error"></div>
                }
              </div>
            </li>
            <li [ngClass]="{ active: menuIndex === 1 }" (click)="goTo(1)">
              <div class="flex align-items-center gap-1">
                <i class="link-o pi pi-ticket"></i>
                <span class="link-o">Voli</span>
                @if (
                form_section_validation.get("section_1")?.valid === false
                ) {
                <div class="alert-error"></div>
                }
              </div>
            </li>
            <li [ngClass]="{ active: menuIndex === 2 }" (click)="goTo(2)">
              <div class="flex align-items-center gap-1">
                <i class="link-o pi pi-images"></i>
                <span class="link-o">Panoramica</span>
                @if (
                form_section_validation.get("section_2")?.valid === false
                ) {
                <div class="alert-error"></div>
                }
              </div>
            </li>
            <li [ngClass]="{ active: menuIndex === 3 }" (click)="goTo(3)">
              <div class="flex align-items-center gap-1">
                <i class="link-o pi pi-tags"></i>
                @if (travel_data?.pricing_mode === 2) {
                <span class="link-o">Pacchetti</span>
                } @else {
                <span class="link-o">Prezzi e alloggio</span>
                }
                @if (
                form_section_validation.get("section_3")?.valid === false
                ) {
                <div class="alert-error"></div>
                }
              </div>
            </li>
            <li [ngClass]="{ active: menuIndex === 4 }" (click)="goTo(4)">
              <div class="flex align-items-center gap-1">
                <i class="link-o pi pi-plus-circle"></i>
                <span class="link-o">Servizi aggiuntivi</span>
                @if (
                form_section_validation.get("section_4")?.valid === false
                ) {
                <div class="alert-error"></div>
                }
              </div>
            </li>
            <li class="green menu-check">
              <i class="check link-o pi pi-check" (click)="menu.toggle($event)"></i>
              <p-menu #menu [model]="items_menu_check" [popup]="true" appendTo="body"></p-menu>
            </li>
          </ul>
          <div class="flex flex-column align-items-center justify-content-center">
            @if (draft_id) {
            <div class="w-full flex align-items-center justify-content-center gap-2 text-xs pb-3">
              @if (!loading) {
              <i class="pi pi-check green"></i>
              } @else {
              <i class="pi pi-spin pi-spinner"></i>
              }
              <span>Salvataggio automatico</span>
            </div>

            <div class="buttons out-green mb-3 w-full">
              <p-button label="Vai alle bozze" size="small" [outlined]="true" (click)="redirect()"></p-button>
            </div>
            <div class="buttons w-full">
              <p-button label="Pubblica" styleClass="w-full slide" (click)="publish()"></p-button>
            </div>
            }
            @if (travel_id) {
            <div class="buttons w-full">
              <p-button label="Salva" styleClass="w-full slide" (click)="updateTravel()"></p-button>
            </div>
            }
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-9 xl:col-9">
        <form [formGroup]="frm_travel">
          <!--INFORMAZIONI BASE-->
          <!-- @switch (menuIndex) {  -->
          <!-- @case (0) { -->
          <div class="mb-3" [hidden]="menuIndex !== 0">
            @if (
            travel_type === EnumEventType.STANDARD &&
            travel_data?.funding === false
            ) {
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-0"></div>
                  <h3>Visibilità del <span class="yellow">viaggio</span></h3>
                  <small class="grey-text">Indica se il tuo viaggio sarà visibile da tutti oppure
                    solo agli utenti in possesso di invito. Puoi scegliere se
                    tutti i travelers di Social Travels possono richiedere
                    l'invito o fare in modo che solo i membri delle tue
                    community lo ricevano.</small>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>Visibilità viaggio*</label>
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="visibility_opt" optionLabel="name" optionValue="id"
                          formControlName="visibility"></p-dropdown>
                        @if (
                        frm_travel.get("visibility")?.errors &&
                        frm_travel.get("visibility")?.dirty
                        ) {
                        <st-travel-errors [errors]="frm_travel.get('visibility')?.errors"></st-travel-errors>
                        }
                      </div>
                    </div>
                    @if (isPrivate) {
                    <div class="col-12 mt-3">
                      <div class="field-checkbox">
                        <p-radioButton [value]="2" inputId="2" formControlName="visibility_id" />
                        <label for="2" class="ml-2">Si può accedere solo tramite invito</label>
                      </div>
                      <!-- <div class="field-checkbox">
                            <p-radioButton
                              [value]="3"
                              inputId="3"
                              formControlName="visibility_id"
                            />
                            <label for="3" class="ml-2"
                              >Sarà possibile richiedere l'invito di
                              partecipazione</label
                            >
                          </div> -->

                      <div class="field-checkbox">
                        <p-radioButton [value]="4" inputId="4" formControlName="visibility_id" />
                        <label for="4" class="ml-2">Solo gli utenti di una o più community possono
                          partecipare</label>
                      </div>
                    </div>
                    @if (throughCommunity) {
                    <div class="col-12">
                      <label>Community a cui mandare l'invito*</label>
                      <div class="w-full mt-1 block">
                        <p-multiSelect *ngIf="communities" styleClass="w-full" [options]="communities"
                          optionLabel="name" optionValue="id" [showClear]="true" display="chip"
                          formControlName="visibility_metadata" emptyMessage="Nessuna community presente."
                          emptyFilterMessage="Nessun risultato trovato.">
                          <ng-template let-c pTemplate="type">
                            <div class="flex align-items-center gap-2">
                              @if (c.picture) {
                              <img [src]="
                                          c.picture | imagePipe: 'user' : 'lg'
                                        " height="24" />
                              } @else {
                              <img src="/assets/media/icons/photos.png" m height="24" />
                              }
                              <span>{{ c.name }}</span>
                              @if (c.public === true) {
                              <i class="grey-text pi pi-lock text-xs"></i>
                              } @else {
                              <i class="grey-text pi pi-lock-open text-xs"></i>
                              }
                            </div>
                          </ng-template>
                          <!-- TEMPLATE FOOTER: BOTTONE CREA COMMUNITY -->
                          <ng-template pTemplate="footer">
                            <div class="p-2 border-top-1 surface-border flex justify-content-center">
                              <button type="button" class="p-button p-button-text p-button-sm yellow"
                                (click)="openNewCommunityModal()">
                                + Crea nuova community
                              </button>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                        @if (
                        frm_travel.get("visibility_metadata")?.errors &&
                        frm_travel.get("visibility_metadata")?.dirty
                        ) {
                        <st-travel-errors [errors]="
                                    frm_travel.get('visibility_metadata')
                                      ?.errors
                                  "></st-travel-errors>
                        }
                      </div>
                    </div>
                    }
                    }
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="undisclosed_members_list" inputId="undisclosed_members_list" />
                        <label for="undisclosed_members_list" class="text-sm mb-1">I partecipanti del viaggio saranno
                          visibili solo
                          agli stessi</label>
                      </div>
                      @if (
                      frm_travel.get("undisclosed_members_list")?.errors &&
                      frm_travel.get("undisclosed_members_list")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                              frm_travel.get('undisclosed_members_list')?.errors
                            "></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
            @if (travel_data?.funding === true) {
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-0"></div>
                  <h3>Visibilità del <span class="yellow">viaggio</span></h3>
                  <small class="grey-text">L'evento GMG è un viaggio al quale viaggiatori/ sponsor
                    potranno accedere solo se in possesso di invito. Al
                    termine della creazione del viaggio, riceverai una e-mail
                    con un QR-code e un link. Potrai condividerli con chiunque
                    tu voglia invitare ad accedere per partecipare all'evento
                    oppure per sponsorizzarlo.</small>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>Visibilità viaggio*</label>
                      <div class="w-full block mt-1">
                        <div class="w-full block mt-1">
                          <p-dropdown styleClass="w-full" [options]="visibility_opt" optionLabel="name" optionValue="id"
                            formControlName="visibility"></p-dropdown>
                        </div>
                      </div>

                      <div class="col-12 mt-3">
                        <div class="field-checkbox">
                          <p-radioButton [value]="2" inputId="2" formControlName="visibility_id" />
                          <label for="2" class="ml-2">Si può accedere solo tramite invito</label>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="flex align-items-center gap-3">
                          <p-inputSwitch formControlName="undisclosed_members_list"
                            inputId="undisclosed_members_list" />
                          <label for="undisclosed_members_list" class="text-sm mb-1">I partecipanti del viaggio saranno
                            visibili solo
                            agli stessi</label>
                        </div>

                        @if (
                        frm_travel.get("undisclosed_members_list")
                        ?.errors &&
                        frm_travel.get("undisclosed_members_list")?.dirty
                        ) {
                        <st-travel-errors [errors]="
                                frm_travel.get('undisclosed_members_list')
                                  ?.errors
                              "></st-travel-errors>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-1"></div>
                  <h3>Presentazione del <span class="green">viaggio</span></h3>
                  <small class="grey-text">Scrivi il titolo, il sottotitolo ed una breve panoramica da
                    mostrare nella pagina del tuo viaggio.</small>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>Titolo del viaggio*</label>

                      <input type="text" pInputText class="w-full mt-1" formControlName="name" />
                      @if (
                      frm_travel.get("name")?.errors &&
                      frm_travel.get("name")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('name')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      @if (!travel_data?.funding ) {
                      <label>Sottotitolo*</label>
                      } @else {
                      <label>Sottotitolo</label>
                      }
                      <input type="text" pInputText class="w-full mt-1" formControlName="payoff" />
                      @if (
                      frm_travel.get("payoff")?.errors &&
                      frm_travel.get("payoff")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('payoff')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <div class="w-full block">
                  @if (!travel_data?.funding ) {
                  <div class="mb-2"><label>Descrizione*</label></div>

                  <p-editor [style]="{ height: '120px' }" [ngClass]="{
                        'p-invalid':
                          frm_travel.get('summary')?.invalid &&
                          frm_travel.get('summary')?.dirty,
                      }" formControlName="summary">
                    <ng-template pTemplate="header">
                      <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Bold"></button>
                        <button type="button" class="ql-italic" aria-label="Italic"></button>
                        <button type="button" class="ql-underline" aria-label="Underline"></button>
                      </span>
                    </ng-template>
                  </p-editor>
                  } @else {
                  <div class="mb-2"><label>Descrizione</label></div>
                  <p-editor [style]="{ height: '120px' }" [ngClass]="{
                        'p-invalid':
                          frm_travel.get('summary')?.invalid &&
                          frm_travel.get('summary')?.dirty,
                      }" formControlName="summary">
                    <ng-template pTemplate="header">
                      <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Bold"></button>
                        <button type="button" class="ql-italic" aria-label="Italic"></button>
                        <button type="button" class="ql-underline" aria-label="Underline"></button>
                      </span>
                    </ng-template>
                  </p-editor>
                  }
                  @if (
                  frm_travel.get("summary")?.errors &&
                  frm_travel.get("summary")?.dirty
                  ) {
                  <st-travel-errors [errors]="frm_travel.get('summary')?.errors"></st-travel-errors>
                  }
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-2"></div>
                  <h3 class="mb-1">
                    Informazioni di <span class="yellow">base</span>
                  </h3>
                  <small class="grey-text">Indica i paesi e le città coinvolte nel tuo viaggio, la
                    data di partenza e quella di ritorno, il numero massimo di
                    partecipanti, insieme alle tipologie che più caratterizzano
                    il tuo viaggio. <br />
                    <b class="dark">Puoi inserire diverse città dividendole con una virgola
                      oppure premendo invio.</b></small>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label class="mb-3">Paesi*</label>

                      <div class="mt-1">
                        <p-autoComplete [forceSelection]="true" formControlName="countries_iso"
                          [suggestions]="suggestedCountries" (completeMethod)="filterCountries($event)" field="name"
                          dataKey="ISO" class="frm mt-1" [multiple]="true" [emptyMessage]="'Nessun risultato trovato'"
                          emptyFilterMessage="Nessun risultato trovato"></p-autoComplete>
                      </div>
                      @if (
                      frm_travel.get("countries_iso")?.errors &&
                      frm_travel.get("countries_iso")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('countries_iso')?.errors"></st-travel-errors>
                      }
                    </div>

                    <div class="col-12">
                      <label class="mb-3">Città*</label>

                      <div class="mt-1">
                        <p-chips [max]="20" formControlName="cities" separator="," [addOnBlur]="true"></p-chips>
                      </div>
                      @if (
                      frm_travel.get("cities")?.errors &&
                      frm_travel.get("cities")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('cities')?.errors"></st-travel-errors>
                      }
                    </div>

                    <div class="col-12 xl:col-8">
                      @if (!travel_data?.funding ) {
                      <label>Dal - Al*</label>
                      } @else {
                      <label>Dal - Al</label>
                      }
                      <div>
                        <p-calendar styleClass="w-full" [showClear]="true" dateFormat="dd/mm/yy" appendTo="body"
                          [showTime]="false" selectionMode="range" [formControl]="rangeDates"></p-calendar>
                      </div>
                      @if (rangeDates.errors && rangeDates.dirty) {
                      <st-travel-errors [errors]="rangeDates.errors"></st-travel-errors>
                      }
                    </div>
                    @if (!travel_data?.funding ) {
                    <div class="col-12 xl:col-4">
                      <label>Max partecipanti*</label>
                      <input type="number" pInputText class="w-full mt-1" formControlName="max_members" />
                      @if (
                      frm_travel.get("max_members")?.errors &&
                      frm_travel.get("max_members")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('max_members')?.errors"></st-travel-errors>
                      }
                    </div>
                    }

                    <div class="col-12">
                      @if (!travel_data?.funding ) {
                      <label>Tipologia di viaggio*</label>
                      } @else {
                      <label> Tipologia di viaggio</label>
                      }
                      <div class="w-full mt-1 block">
                        <p-multiSelect styleClass="w-full" [options]="types" optionLabel="name" [filter]="false"
                          [showHeader]="false" optionValue="id" [showClear]="true" display="chip"
                          formControlName="categories">
                          <ng-template let-t pTemplate="type">
                            <div class="flex align-items-center gap-2">
                              <img [src]="t.id | travelType" alt="" />
                              <span>{{ t.name }}</span>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </div>
                      @if (
                      frm_travel.get("categories")?.errors &&
                      frm_travel.get("categories")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('categories')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-3"></div>
                  <h3 class="mb-1">
                    Fornitore e <span class="green">accompagnatore</span>
                  </h3>
                  <small class="grey-text">Non sei un Tour Leader Pro? Qui puoi indicare se il tuo
                    viaggio ha uno sponsor/fornitore con p.Iva e i dati del tuo
                    accompagnatore.
                  </small>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>Organizzazione tecnica</label>
                      <div class="w-full mt-1 block">
                        <p-autoComplete [forceSelection]="true" [formControl]="player" [suggestions]="suggestedPlayers"
                          (completeMethod)="filterPlayers($event)" field="name" dataKey="id" class="frm mt-1"
                          [emptyMessage]="'Nessun risultato trovato'"
                          emptyFilterMessage="Nessun risultato trovato"></p-autoComplete>
                      </div>
                    </div>

                    @if (companion != undefined) {
                    <h4 class="mb-0">Accompagnatore del viaggio</h4>
                    <div class="col-12">
                      <div class="flex align-items-center gap-3 mt-3">
                        <div class="companion-placeholder">
                          <img [src]="
                                companion.profile_picture
                                  | imagePipe: 'user-w' : 'sm'
                              " width="60" height="60" />
                        </div>
                        <div>
                          <span class="mb-2">{{ companion.name }}
                            {{ companion.last_name }}</span>
                          <div class="grey-text companion_desc">
                            <small [innerHTML]="companion.description"></small>
                          </div>
                        </div>
                      </div>
                    </div>
                    }

                    <div class="col-12">
                      <div class="out-green mt-2">
                        <p-button [label]="
                            !companion
                              ? 'Aggiungi accompagnatore'
                              : 'Cambia accompagnatore'
                          " styleClass="px-6" [outlined]="true" size="small" (click)="openCompanionModal()"></p-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (auth.isTourLeaderPro()) {
            <div class="form-section">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-3-b"></div>
                  <h3 class="mb-1">
                    Delega un <span class="yellow">Tour Leader</span>
                  </h3>
                  <small class="grey-text">Se decidi di delegare questo viaggio ad un altro Tour
                    Leader, questo riceverà una notifica per l'accettazione
                    dell'incarico.
                  </small>
                </div>

                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <div [ngClass]="{ disabled: requestDone || isPending }">
                        <label>Cerca un Tour Leader</label>
                        <div class="w-full mt-1 block">
                          <p-autoComplete [forceSelection]="true" [formControl]="assignedTourleader"
                            [suggestions]="suggestedTourLeaders" (completeMethod)="filterLeaders($event)" field="name"
                            dataKey="id" class="frm mt-1" [emptyMessage]="'Nessun risultato trovato'"
                            emptyFilterMessage="Nessun risultato trovato">
                            <ng-template let-leader pTemplate="item">
                              <div class="flex align-items-center gap-2">
                                <p-avatar [image]="
                                    leader.profile_picture
                                      | imagePipe: 'user' : 'sm'
                                  " shape="circle"></p-avatar>
                                <div>
                                  {{ leader.name }} {{ leader.last_name }}
                                </div>
                              </div>
                            </ng-template>
                          </p-autoComplete>
                        </div>
                      </div>
                      @if (assignedTourleader.value != undefined) {
                      <h4 class="mb-0">Tour Leader del viaggio</h4>
                      <div class="col-12">
                        <div class="flex align-items-center gap-3 mt-3">
                          <div class="companion-placeholder">
                            <img [src]="
                                  assignedTourleader.value.profile_picture
                                    | imagePipe: 'user-w' : 'sm'
                                " width="60" height="60" />
                          </div>
                          <div>
                            <span class="block mb-2">{{ assignedTourleader.value.name }}
                              {{ assignedTourleader.value.last_name }}</span>
                            @if (
                            assignedTourleader.value.role.id ===
                            enumUserRoles.TOURLEADER
                            ) {
                            <div class="badge-container muted-o-bg mb-3 flex justify-content-center">
                              <small class="dark font-semibold">Tour Leader</small>
                            </div>
                            }
                            @if (
                            assignedTourleader.value.role.id ===
                            enumUserRoles.TOURLEADER_PRO
                            ) {
                            <div class="badge-container muted-s-bg mb-3 flex justify-content-center">
                              <small class="dark font-semibold">Tour Leader Pro</small>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      @if (
                      travel_data?.assignment?.status?.id ===
                      enumAssignmentStatus.ACCEPTED
                      ) {
                      <small class="green">Questo Tour Leader ha accettato la
                        richiesta.</small>
                      }
                      }
                    </div>
                    @if (
                    assignedTourleader.value != undefined &&
                    travel_data?.assignment?.status?.id !=
                    enumAssignmentStatus.ACCEPTED
                    ) {
                    <!-- @if(!requestRevoked){ -->
                    <div class="col-12">
                      <div class="out-green mt-2">
                        <p-button [label]="
                              requestDone
                                ? 'Richiesta inviata'
                                : 'Invia richiesta'
                            " styleClass="px-6" [outlined]="true" size="small" (click)="sendAssignmentRequest()"
                          [disabled]="requestDone"></p-button>
                      </div>
                    </div>
                    <!-- } (travel_data?.assignment?.status?.id === enumAssignmentStatus.PENDING)-->
                    @if (requestDone || isPending) {
                    <div class="col-12">
                      <div class="red">
                        <p-button label="Revoca richiesta" [text]="true" size="small"
                          (click)="revokeAssignmentRequest()"></p-button>
                      </div>
                    </div>
                    }
                    }
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
          <!-- }  -->
          <!-- @case (1) { -->
          <!--PARTENZE E VOLI-->
          <div class="mb-3" [hidden]="menuIndex !== 1">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-4"></div>
                  <h3>Informazioni sui <span class="green">voli</span></h3>
                  <small class="grey-text">Puoi decidere se il tuo viaggio comprende i voli di andata
                    e di ritorno, e se è possibile acquistarli separatamente
                    applicando uno sconto sul prezzo finale.</small>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="has_flights" inputId="has_flights" />
                        <label for="has_flights" class="text-sm mb-1">Il viaggio include i voli di andata e di
                          ritorno</label>
                      </div>
                      @if (
                      frm_travel.get("has_flights")?.errors &&
                      frm_travel.get("has_flights")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('has_flights')?.errors"></st-travel-errors>
                      }
                    </div>
                    <!-- AGGIUNTO CONTROLLO SE FUNDING NON VEDO SEC SWITCH E "SCONTO SENZA VOLI" -->
                    @if (!travel_data?.funding ) {
                    @if (this.frm_travel.get("has_flights")?.value === true) {
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="optional_flight_purchase" inputId="optional_flight_purchase" />
                        <label for="optional_flight_purchase" class="text-sm mb-1">È possibile acquistare questo viaggio
                          senza volo
                          con uno sconto</label>
                      </div>
                      @if (
                      frm_travel.get("optional_flight_purchase")
                      ?.errors &&
                      frm_travel.get("optional_flight_purchase")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                                frm_travel.get('optional_flight_purchase')
                                  ?.errors
                              "></st-travel-errors>
                      }
                    </div>
                    }
                    @if (
                    this.frm_travel.get("has_flights")?.value === true &&
                    frm_travel.get("optional_flight_purchase")?.value ===
                    true
                    ) {
                    <div class="col-12 mt-2">
                      <label>Sconto viaggio senza voli*</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="optional_flight_purchase_discount" />
                        </p-inputGroup>
                      </div>
                    </div>
                    }
                    }
                  </div>
                </div>
              </div>
            </div>
            @if (this.frm_travel.get("has_flights")?.value === true) {
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div>
                    <div class="section-icon img-5"></div>
                    <h3>Voli di <span class="yellow">andata</span></h3>
                    <small class="grey-text">Indica tutte le informazioni sui voli di andata,
                      compresi i voli che prevedono uno scalo.</small>
                  </div>
                </div>

                <div class="col pb-0">
                  @for (d of frmDepControls; track d) {
                  @if (frmDepControls.length > 1) {
                  <h4>
                    Volo <span class="green">{{ $index + 1 }}</span>
                    <i class="pi pi-trash ml-2 mb-3 clickable text-xs" (click)="remove($index, frmDep)"></i>
                  </h4>
                  }
                  <div class="grid" [formGroup]="d">
                    <div class="col-6">
                      @if (!travel_data?.funding ) {
                      <label>Compagnia aerea*</label>
                      } @else {
                      <label>Compagnia aerea</label>
                      }
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="companies" [showClear]="true"
                          formControlName="flight_company" optionLabel="name" optionValue="code" [filter]="true"
                          filterBy="name" emptyMessage="Nessun risultato trovato"
                          emptyFilterMessage="Nessun risultato trovato"></p-dropdown>
                      </div>
                      @if (
                      d.get("flight_company")?.errors &&
                      d.get("flight_company")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('flight_company')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-6">
                      @if (!travel_data?.funding ) {
                      <label>Numero volo*</label>
                      } @else {
                      <label>Numero volo</label>
                      }
                      <input type="text" pInputText class="w-full mt-1" formControlName="flight_number" />
                      @if (
                      d.get("flight_number")?.errors &&
                      d.get("flight_number")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('flight_number')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Aeroporto di partenza*</label>
                      } @else {
                      <label>Aeroporto di partenza</label>
                      }
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="airports" [showClear]="true"
                          formControlName="from_airport" optionLabel="name" optionValue="code" [filter]="true"
                          filterBy="name" emptyMessage="Nessun risultato trovato"
                          emptyFilterMessage="Nessun risultato trovato"></p-dropdown>
                      </div>
                      @if (
                      d.get("from_airport")?.errors &&
                      d.get("from_airport")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('from_airport')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Partenza*</label>
                      } @else {
                      <label>Partenza</label>
                      }
                      <!-- {{d.get('departure_date')?.value}} -->
                      <div class="w-full block">
                        <p-calendar styleClass="w-full" dateFormat="dd/mm/yy" formControlName="departure_date"
                          appendTo="body" [firstDayOfWeek]="1" [showTime]="true" hourFormat="24"
                          [minDate]="travel_from ? travel_from : today"></p-calendar>
                        <!-- [minDate]="travel_from ? travel_from : today" -->
                      </div>
                      @if (
                      d.get("departure_date")?.errors &&
                      d.get("departure_date")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('departure_date')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Aeroporto di arrivo*</label>
                      } @else {
                      <label>Aeroporto di arrivo</label>
                      }
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="airports" [showClear]="true"
                          formControlName="to_airport" optionLabel="name" optionValue="code" [filter]="true"
                          filterBy="name" emptyMessage="Nessun risultato trovato"
                          emptyFilterMessage="Nessun risultato trovato"></p-dropdown>
                      </div>
                      @if (
                      d.get("to_airport")?.errors &&
                      d.get("to_airport")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('to_airport')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Arrivo*</label>
                      } @else {
                      <label>Arrivo</label>
                      }
                      <div class="w-full block">
                        <p-calendar styleClass="w-full" dateFormat="dd/mm/yy" formControlName="arrival_date"
                          appendTo="body" panelStyleClass="custom-calendar" [firstDayOfWeek]="1" [showTime]="true"
                          hourFormat="24" [minDate]="d.get('departure_date')?.value"></p-calendar>
                      </div>
                      @if (
                      d.get("arrival_date")?.errors &&
                      d.get("arrival_date")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('arrival_date')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                  }
                  <div class="flex out-green justify-content-center md:justify-content-end mt-4">
                    <p-button (click)="addDepartureFlight()" label="Aggiungi volo" size="small" styleClass="px-6"
                      [outlined]="true"></p-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-6"></div>
                      <h3>Voli di <span class="green">ritorno</span></h3>
                      <small class="grey-text">Indica tutte le informazioni sui voli di ritorno,
                        compresi i voli che prevedono uno scalo.</small>
                    </div>
                  </div>
                </div>
                <div class="col pb-0">
                  @for (d of frmArrControls; track d) {
                  @if (frmArrControls.length > 1) {
                  <h4>
                    Volo <span class="yellow">{{ $index + 1 }}</span>
                    <i class="pi pi-trash ml-2 mb-3 clickable text-xs" (click)="remove($index, frmArr)"></i>
                  </h4>
                  }
                  <div class="grid" [formGroup]="d">
                    <div class="col-6">
                      @if (!travel_data?.funding ) {
                      <label>Compagnia aerea*</label>
                      } @else {
                      <label>Compagnia aerea</label>
                      }
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="companies" [showClear]="true"
                          formControlName="flight_company" optionLabel="name" optionValue="code" [filter]="true"
                          filterBy="name" emptyMessage="Nessun risultato trovato"
                          emptyFilterMessage="Nessun risultato trovato"></p-dropdown>
                      </div>
                      @if (
                      d.get("flight_company")?.errors &&
                      d.get("flight_company")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('flight_company')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-6">
                      @if (!travel_data?.funding ) {
                      <label>Numero volo*</label>
                      } @else {
                      <label>Numero volo</label>
                      }
                      <input type="text" pInputText class="w-full mt-1" formControlName="flight_number" />
                      @if (
                      d.get("flight_number")?.errors &&
                      d.get("flight_number")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('flight_number')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Aeroporto di partenza*</label>
                      } @else {
                      <label>Aeroporto di partenza</label>
                      }
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="airports" [showClear]="true"
                          formControlName="from_airport" optionLabel="name" optionValue="code" [filter]="true"
                          filterBy="name" emptyMessage="Nessun risultato trovato"
                          emptyFilterMessage="Nessun risultato trovato"></p-dropdown>
                      </div>
                      @if (
                      d.get("from_airport")?.errors &&
                      d.get("from_airport")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('from_airport')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Partenza*</label>
                      } @else {
                      <label>Partenza</label>
                      }
                      <div class="w-full block">
                        <p-calendar styleClass="w-full" dateFormat="dd/mm/yy" formControlName="departure_date"
                          appendTo="body" panelStyleClass="custom-calendar" [minDate]="travel_to" [firstDayOfWeek]="1"
                          [showTime]="true" hourFormat="24"></p-calendar>
                      </div>
                      @if (
                      d.get("departure_date")?.errors &&
                      d.get("departure_date")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('departure_date')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Aeroporto di arrivo*</label>
                      } @else {
                      <label>Aeroporto di arrivo</label>
                      }
                      <div class="w-full block mt-1">
                        <p-dropdown styleClass="w-full" [options]="airports" [showClear]="true"
                          formControlName="to_airport" optionLabel="name" optionValue="code" [filter]="true"
                          filterBy="name" emptyMessage="Nessun risultato trovato"
                          emptyFilterMessage="Nessun risultato trovato"></p-dropdown>
                      </div>
                      @if (
                      d.get("to_airport")?.errors &&
                      d.get("to_airport")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('to_airport')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      @if (!travel_data?.funding ) {
                      <label>Arrivo*</label>
                      } @else {
                      <label>Arrivo</label>
                      }
                      <div class="w-full block">
                        <p-calendar styleClass="w-full" dateFormat="dd/mm/yy" formControlName="arrival_date"
                          appendTo="body" [firstDayOfWeek]="1" [showTime]="true" hourFormat="24"
                          [minDate]="d.get('departure_date')?.value"></p-calendar>
                      </div>
                      @if (
                      d.get("arrival_date")?.errors &&
                      d.get("arrival_date")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('arrival_date')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                  }
                  <div class="flex out-green justify-content-center md:justify-content-end mt-4">
                    <p-button label="Aggiungi volo" size="small" styleClass="px-6" (click)="addArrivalFlight()"
                      [outlined]="true"></p-button>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
          <!-- }  -->
          <!-- @case (2) { -->
          <!--DESCRIZIONE-->
          <div class="mb-3" [hidden]="menuIndex !== 2">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-7"></div>
                      <h3>Programma del <span class="yellow">viaggio</span></h3>
                      <small class="grey-text">Inserisci il programma del viaggio giorno per giorno o
                        facendo sapere ai travelers cosa li aspetta durante il
                        viaggio.</small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  @for (p of frmProgramDayControls; track p) {
                  @if (frmProgramDayControls.length > 1) {
                  <div class="flex align-items-center">
                    <h4 class="green">{{ $index + 1 }}</h4>
                    <i class="pi pi-trash ml-2 clickable text-xs" (click)="remove($index, frmProgramDay)"></i>
                  </div>
                  }
                  <div class="grid" [formGroup]="p">
                    <div class="col-12">
                      @if (!travel_data?.funding ) {
                      <label>Titolo*</label>
                      } @else {
                      <label>Titolo</label>
                      }
                      <input type="text" pInputText class="w-full mt-1" formControlName="title" />
                      @if (p.get("title")?.errors && p.get("title")?.dirty) {
                      <st-travel-errors [errors]="p.get('title')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      @if (!travel_data?.funding ) {
                      <label>Descrizione*</label>
                      } @else {
                      <label> Descrizione</label>
                      }

                      <div class="w-full block mt-1">
                        <textarea rows="5" cols="30" pInputTextarea class="w-full" formControlName="description">
                          </textarea>
                      </div>
                      @if (
                      p.get("description")?.errors &&
                      p.get("description")?.dirty
                      ) {
                      <st-travel-errors [errors]="p.get('description')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                  }
                  <div class="flex out-green justify-content-center md:justify-content-end mt-4">
                    <p-button label="Aggiungi" size="small" styleClass="px-6" (click)="addProgramDay()"
                      [outlined]="true"></p-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                @if (!travel_data?.funding ) {
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-8"></div>
                  <h3>Informazioni sulla <span class="green">quota</span></h3>
                  <small class="grey-text">Fai sapere ai travelers cosa comprende e cosa non
                    comprende la quota del tuo viaggio.</small>
                  <br />
                  <small class="font-bold">Puoi inserire i vari elementi dividendoli con un punto e
                    virgola/ premendo invio oppure puoi copiare e incollare
                    una lista di inclusioni/ esclusioni (i vari elementi
                    divisi da punto e virgola, testo a capo o trattino
                    alto).</small>
                </div>

                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>La quota comprende*</label>
                      <div class="w-full block mt-1">
                        <p-chips formControlName="price_includes" [separator]="acceptedSeparators" [addOnBlur]="true" />
                      </div>
                      @if (
                      frm_travel.get("price_includes")?.errors &&
                      frm_travel.get("price_includes")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price_includes')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>La quota NON comprende*</label>
                      <div class="w-full block mt-1">
                        <p-chips formControlName="price_excludes" [separator]="acceptedSeparators" [addOnBlur]="true" />
                      </div>
                      @if (
                      frm_travel.get("price_excludes")?.errors &&
                      frm_travel.get("price_excludes")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price_excludes')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
                } @else {
                <!-- FINTO DISABLED PER FUNDING TRUE UI -->
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-8"></div>
                  <h3>Informazioni sulla <span class="green">quota</span></h3>
                  <small class="grey-text">Fai sapere ai travelers cosa comprende e cosa non
                    comprende la quota del tuo viaggio.</small>
                  <br />
                  <small class="font-bold">Puoi inserire i vari elementi dividendoli con un punto e
                    virgola/ premendo invio oppure puoi copiare e incollare
                    una lista di inclusioni/ esclusioni (i vari elementi
                    divisi da punto e virgola, testo a capo o trattino
                    alto).</small>
                </div>
                <div class="col opacity-50 pointer-events-none">
                  <div class="grid">
                    <div class="col-12">
                      <label class="text-gray-400">La quota comprende</label>
                      <div class="w-full block mt-1">
                        <p-chips [separator]="acceptedSeparators" [addOnBlur]="true"></p-chips>
                      </div>
                    </div>
                    <div class="col-12">
                      <label class="text-gray-400">La quota NON comprende</label>
                      <div class="w-full block mt-1">
                        <p-chips separator="," [addOnBlur]="true"></p-chips>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-right">
                  <span class="yellow mt3 text-xs">* Potrai definire le informazioni in fase di finalizzazione</span>
                </div>
                }
                <!-- FINTO DISABLED PER FUNDING TRUE UI -->
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12">
                  <div class="section-icon img-9"></div>
                  <h3>Immagini e <span class="yellow">video</span></h3>
                  <small class="grey-text">Carica la foto dei paesi che tu e i travelers andrete a
                    visitare. Puoi anche inserire il link di un video Youtube
                    per promuovere o preparare i travelers al viaggio.</small>
                  <div
                    class="flex align-items-center justify-content-center md:justify-content-start gap-3 mt-5 flex-wrap">
                    @if (travel_img && travel_img.length > 0) {
                    @for (img of travel_img; track $index) {
                    <div class="travel-placeholder img">
                      <img [src]="
                              travel_img![$index].media
                                | imagePipe: 'user' : 'lg'
                            " />
                      <div class="delete-img">
                        <i class="pi pi-trash" (click)="
                                deleteImg(travel_img![$index].media.id, $index)
                              "></i>
                      </div>
                    </div>
                    }
                    } @else {
                    <div class="travel-placeholder">
                      <img src="/assets/media/icons/photos.png" width="60" />
                    </div>
                    }
                    @if (travel_img && travel_img!.length > 0) {
                    <div
                      class="add-travel-img flex align-items-center justify-content-center md:justify-content-start gap-2">
                      @if (imgLoading) {
                      <i class="pi pi-spin pi-spinner"></i>
                      } @else {
                      <i class="pi pi-plus link-o green" (click)="openTravelImagePicker()" pTooltip="Carica foto"
                        tooltipPosition="top"></i>
                      <i class="pi pi-search link-o green" (click)="openCloudImagePickerModal()" pTooltip="Cerca foto"
                        tooltipPosition="top"></i>
                      }
                    </div>
                    } @else {
                    @if (imgLoading) {
                    <i class="pi pi-spin pi-spinner"></i>
                    } @else {
                    <div class="flex align-items-center gap-1">
                      <span class="link-o green" (click)="openTravelImagePicker()">Carica una foto</span>
                      <span class="grey-text">oppure</span>
                      <span class="link-o green" (click)="openCloudImagePickerModal()">cerca una foto nel cloud</span>
                    </div>
                    }
                    }
                  </div>
                </div>
                <div class="col-12">
                  <label>URL Youtube</label>
                  <div class="w-full block mt-1">
                    <input type="text" formControlName="youtube_url" pInputText class="w-full mt-1" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- } -->
          <!-- @case (3){ -->
          <!--PREZZI E ALLOGGIO / PACCHETTI-->
          @if (travel_data?.pricing_mode === 2) {
          <!--PACCHETTI-->
          <div class="mb-3" [hidden]="menuIndex !== 3">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-10"></div>
                      <h3>
                        Valuta del <span class="yellow">pagamento</span>
                      </h3>
                      <small class="grey-text">Inserisci la valuta con la quale verrà pagato il
                        prezzo del viaggio.</small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>Valuta*</label>
                      <div class="block w-full mt-1">
                        <p-dropdown styleClass="w-full" [options]="currency" optionLabel="name" optionValue="name"
                          formControlName="currency"></p-dropdown>
                      </div>
                      @if (
                      frm_travel.get("currency")?.errors &&
                      frm_travel.get("currency")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('currency')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="section-icon img-4_2"></div>
                  <h3>
                    Informazioni sui <span class="green">pacchetti</span>
                  </h3>
                  <small class="grey-text">Definisci la configurazione dei pacchetti viaggio
                    acquistabili dagli utenti. Indica cosa offre il pacchetto,
                    per quante persone è disponibile, se è acquistabile per un
                    massimo di utenti oppure è illimitato.</small>
                </div>
                <div class="col">
                  @for (d of frmPckgsControls; track d) {
                  <div class="grid" [formGroup]="d">
                    <div class="col-12">
                      @if (frmPckgsControls.length > 1) {
                      <h4>
                        Pacchetto
                        <span class="green">{{ $index + 1 }}</span>
                        <i class="pi pi-trash ml-2 clickable text-xs" (click)="remove($index, frmPckgs)"></i>
                      </h4>
                      }
                      @if (!travel_data?.funding ) {
                      <label>Nome*</label>
                      } @else {
                      <label>Nome</label>
                      }
                      <input type="text" pInputText formControlName="name" class="w-full mt-1" />
                      @if (d.get("name")?.errors && d.get("name")?.dirty) {
                      <st-travel-errors [errors]="d.get('name')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      @if (!travel_data?.funding ) {
                      <label>Descrizione*</label>
                      } @else {
                      <label> Descrizione</label>
                      }
                      <div class="w-full block mt-1">
                        <p-editor [style]="{ height: '120px' }" [ngClass]="{
                                'p-invalid':
                                  d.get('description')?.invalid &&
                                  d.get('description')?.dirty,
                              }" placeholder="Descrizione del pacchetto..." formControlName="description">
                          <ng-template pTemplate="header">
                            <span class="ql-formats">
                              <button type="button" class="ql-bold" aria-label="Bold"></button>
                              <button type="button" class="ql-italic" aria-label="Italic"></button>
                              <button type="button" class="ql-underline" aria-label="Underline"></button>
                            </span>
                          </ng-template>
                        </p-editor>
                        @if (
                        d.get("description")?.errors &&
                        d.get("description")?.dirty
                        ) {
                        <st-travel-errors [errors]="d.get('description')?.errors"></st-travel-errors>
                        }
                      </div>
                    </div>
                    <div class="col-12 xl:col-7">
                      <div class="flex align-items-center gap-1">
                        @if (!travel_data?.funding ) {
                        <label>Partecipanti per prenotazione*</label>
                        } @else {
                        <label> Partecipanti per prenotazione</label>
                        }
                        <i class="pi pi-info-circle text-xs"
                          pTooltip="Indicare il numero di adulti previsto per il pacchetto (es. Camera doppia - 2)"></i>
                      </div>
                      <input type="number" pInputText formControlName="n_partecipants" class="w-full mt-1" />
                      @if (
                      d.get("n_partecipants")?.errors &&
                      d.get("n_partecipants")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('n_partecipants')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 xl:col-5">
                      <div class="flex align-items-center gap-1">
                        @if (!travel_data?.funding ) {
                        <label>Prezzo per adulto*</label>
                        } @else {
                        <label> Prezzo per adulto</label>
                        }
                        <i class="pi pi-info-circle text-xs"
                          pTooltip="Il prezzo totale sarà calcolato moltiplicando il prezzo per il numero di partecipanti indicato."></i>
                      </div>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_per_person" />
                        </p-inputGroup>
                      </div>
                      @if (
                      d.get("price_per_person")?.errors &&
                      d.get("price_per_person")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                                frm_travel.get('price_per_person')?.errors
                              "></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="tmp_children_and_infants_ok" inputId="children_and_infants_ok"
                          (onChange)="checkPckgAdultsOnly(d)" />
                        <label for="children_and_infants_ok" class="text-sm mb-1">Bambini e neonati ammessi</label>
                      </div>
                    </div>
                    @if (
                    d.get("tmp_children_and_infants_ok")?.value === true
                    ) {
                    <div class="col-12 xl:col-5">
                      <div class="flex align-items-center gap-1">
                        <label>Prezzo per bambino (2-8)*</label>
                      </div>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value
                            | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_per_children" />
                        </p-inputGroup>
                      </div>
                      @if (
                      d.get("price_per_children")?.errors &&
                      d.get("price_per_children")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                                  frm_travel.get('price_per_children')?.errors
                                "></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 xl:col-5">
                      <div class="flex align-items-center gap-1">
                        <label>Prezzo per neonato (0-2)*</label>
                      </div>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value
                            | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_per_infant" />
                        </p-inputGroup>
                      </div>
                      @if (
                      d.get("price_per_infant")?.errors &&
                      d.get("price_per_infant")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                                  frm_travel.get('price_per_infant')?.errors
                                "></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      <div class="flex align-items-center gap-1">
                        <label>Numero massimo di bambini*</label>
                      </div>
                      <input type="number" pInputText formControlName="max_n_children" class="w-full mt-1" />
                      @if (
                      d.get("max_n_children")?.errors &&
                      d.get("max_n_children")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('max_n_children')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12 md:col-6">
                      <div class="flex align-items-center gap-1">
                        <label>Numero massimo di neonati*</label>
                      </div>
                      <input type="number" pInputText formControlName="max_n_infants" class="w-full mt-1" />
                      @if (
                      d.get("max_n_infants")?.errors &&
                      d.get("max_n_infants")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('max_n_infants')?.errors"></st-travel-errors>
                      }
                    </div>
                    }
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="limited" inputId="has_limit" (onChange)="checkLimitedPckg(d)" />
                        <label for="has_limit" class="text-sm mb-1">Disponibilità limitata</label>
                      </div>
                      @if (
                      d.get("limited")?.errors && d.get("limited")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('limited')?.errors"></st-travel-errors>
                      }
                    </div>
                    @if (d.get("limited")?.value === true) {
                    <div class="col-12">
                      <label>Numero massimo di prenotazioni*</label>
                      <input type="number" pInputText formControlName="max_bookings" class="w-full mt-1" />
                      @if (
                      d.get("max_bookings")?.errors &&
                      d.get("max_bookings")?.dirty
                      ) {
                      <st-travel-errors [errors]="d.get('max_bookings')?.errors"></st-travel-errors>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>

              <div class="out-green my-4">
                <div class="flex justify-content-center md:justify-content-end">
                  <p-button (click)="addPackage()" label="Aggiungi pacchetto" size="small" styleClass="px-6"
                    [outlined]="true" [disabled]="travel_data?.funding"></p-button>
                </div>

                @if (travel_data?.funding ) {
                <div class="mt-4 text-center md:text-right text-xs yellow">
                  * Avrai la possibilità di integrare il pacchetto
                  in fase di finalizzazione.
                </div>
                }
              </div>
            </div>

            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-14"></div>
                      <h3>Metodo di <span class="yellow">pagamento</span></h3>
                      <!-- <small class="grey-text">Il viaggio sarà saldabile fino a 30 giorni prima
                                                della partenza. Sia l'acconto che il saldo possono essere pagati con
                                                bonifico o tramite Stripe.</small> -->
                      <small class="grey-text">Sia l'acconto che il saldo possono essere pagati
                        tramite Bonifico SEPA o Carta di credito/ Altro. La
                        scadenza del saldo prevista in automatico dal sistema
                        è 30 giorni prima della partenza. <br /><b class="dark">Il costo del servizio (3%) può essere a
                          carico
                          dell'organizzatore o del viaggiatore.</b></small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <!-- <p-inputSwitch formControlName="checkout_full_payment"
                                                    inputId="checkout_full_payment" />
                                                <label for="checkout_full_payment" class="text-sm mb-1">Pagamento
                                                    completo al checkout</label>-->
                      </div>
                      <!-- @if(frm_travel.get('checkout_full_payment')?.errors &&
                                            frm_travel.get('checkout_full_payment')?.dirty){
                                            <st-travel-errors
                                                [errors]="frm_travel.get('checkout_full_payment')?.errors"></st-travel-errors>
                                            } -->
                    </div>
                    <!-- @if(frm_travel.get('checkout_full_payment')?.value === false){ -->
                    @if (!travel_data?.funding ) {
                    <div class="col-12 md:col-6 lg:col-6">
                      <label>Anticipo</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="checkout_advance" />
                        </p-inputGroup>
                        @if (
                        frm_travel.get("checkout_advance")?.errors &&
                        frm_travel.get("checkout_advance")?.dirty
                        ) {
                        <st-travel-errors [errors]="
                                  frm_travel.get('checkout_advance')?.errors
                                "></st-travel-errors>
                        }
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6">
                      <label>Scadenza saldo</label>
                      <div>
                        <p-calendar styleClass="w-full" [showClear]="true" dateFormat="dd/mm/yy" appendTo="body"
                          [showTime]="false" [formControl]="payoff_due_date_control"></p-calendar>
                      </div>
                    </div>
                    } @else {
                    <div class="col-12 md:col-6 lg:col-6 opacity-60 pointer-events-none">
                      <label>Anticipo</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon class="bg-gray-100">{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText [disabled]="true" class="bg-gray-100" />
                        </p-inputGroup>
                      </div>
                    </div>

                    <div class="col-12 md:col-6 lg:col-6 opacity-60 pointer-events-none">
                      <label>Scadenza saldo</label>
                      <div>
                        <p-calendar styleClass="w-full bg-gray-100" [showClear]="false" dateFormat="dd/mm/yy"
                          appendTo="body" [showTime]="false" [disabled]="true"></p-calendar>
                      </div>
                    </div>
                    }
                    @if (travel_data?.funding ) {
                    <div class="col-12 flex flex-column">
                      <!-- Testo in basso -->
                      <div class="mt-auto text-right text-xs yellow pt-2">
                        * Avrai la possibilità di integrare il metodo di pagamento in fase di finalizzazione.

                      </div>
                    </div>
                    }
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="customer_pays_fees" inputId="customer_pays_fees" />
                        <label for="customer_pays_fees" class="text-sm mb-1">Costi di servizio a carico del
                          viaggiatore</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-12"></div>
                      <h3>
                        Termini e
                        <span class="green">condizioni</span>
                      </h3>

                      <small class="grey-text">
                        I termini e le condizioni di partecipazione includono
                        politiche di cancellazione, modalità di rimborso e
                        responsabilità del viaggiatore. <br />
                        <b class="dark">
                          La conferma di partecipazione da parte dei travelers
                          implica l’accettazione dei termini e delle
                          condizioni.</b>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <div class="flex align-items-center gap-3"></div>
                    </div>
                    @if (!travel_data?.funding ) {
                    <div class="col-12 md:col-6 lg:col-6">
                      <label>Termine prenotazioni*</label>
                      <div>
                        <p-calendar styleClass="w-full" [showClear]="true" dateFormat="dd/mm/yy" appendTo="body"
                          [showTime]="false" [formControl]="booking_deadline"></p-calendar>
                        @if (
                        frm_travel.get("booking_deadline")?.errors &&
                        frm_travel.get("booking_deadline")?.dirty
                        ) {
                        <st-travel-errors [errors]="
                                  frm_travel.get('booking_deadline')?.errors
                                "></st-travel-errors>
                        }
                      </div>
                    </div>
                    }
                    <div class="col-12">
                      <label>Termini e condizioni*</label>

                      <div class="w-full block mt-1">
                        <p-editor [style]="{ height: '120px' }" [ngClass]="{
                              'p-invalid':
                                frm_travel.get('terms_and_conds')?.invalid &&
                                frm_travel.get('terms_and_conds')?.dirty,
                            }" formControlName="terms_and_conds">
                          <ng-template pTemplate="header">
                            <span class="ql-formats">
                              <button type="button" class="ql-bold" aria-label="Bold"></button>
                              <button type="button" class="ql-italic" aria-label="Italic"></button>
                              <button type="button" class="ql-underline" aria-label="Underline"></button>
                            </span>
                          </ng-template>
                        </p-editor>
                      </div>
                      @if (
                      frm_travel.get("terms_and_conds")?.errors &&
                      frm_travel.get("terms_and_conds")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('terms_and_conds')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } @else {
          <!--PREZZI E ALLOGGIO-->
          <div class="mb-3" [hidden]="menuIndex !== 3">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-10"></div>
                      <h3>
                        Valuta del <span class="yellow">pagamento</span>
                      </h3>
                      <small class="grey-text">Inserisci la valuta con la quale verrà pagato il
                        prezzo del viaggio.</small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <label>Valuta*</label>
                      <div class="block w-full mt-1">
                        <p-dropdown styleClass="w-full" [options]="currency" optionLabel="name" optionValue="name"
                          formControlName="currency"></p-dropdown>
                      </div>
                      @if (
                      frm_travel.get("currency")?.errors &&
                      frm_travel.get("currency")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('currency')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-11"></div>
                      <h3>Prezzo delle <span class="green">camere</span></h3>
                      <small class="grey-text">Il costo della camera doppia configura il costo base
                        di partecipazione al viaggio. I partecipanti che
                        decideranno di unirsi al viaggio soli o in più persone
                        pagheranno le quote per le camere singole, triple e
                        quadruple.</small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-6 md:col-12 xl:col-6">
                      <label>Costo camera doppia</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_room" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price_room")?.errors &&
                      frm_travel.get("price_room")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price_room')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-6 md:col-12 xl:col-6">
                      <label>Supplemento camera singola</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_addl_single" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price_addl_single")?.errors &&
                      frm_travel.get("price_addl_single")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                              frm_travel.get('price_addl_single')?.errors
                            "></st-travel-errors>
                      }
                    </div>
                    <div class="col-6 md:col-12 xl:col-6">
                      <label>Riduzione camera tripla</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_sub_triple" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price_sub_triple")?.errors &&
                      frm_travel.get("price_sub_triple")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                              frm_travel.get('price_sub_triple')?.errors
                            "></st-travel-errors>
                      }
                    </div>
                    <div class="col-6 md:col-12 xl:col-6">
                      <label>Riduzione camera quadrupla</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_sub_quad" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price_sub_quad")?.errors &&
                      frm_travel.get("price_sub_quad")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price_sub_quad')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-6 md:col-12 xl:col-6">
                      <label>Riduzione child (2-8 anni)</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_sub_infant" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price_sub_infant")?.errors &&
                      frm_travel.get("price_sub_infant")?.dirty
                      ) {
                      <st-travel-errors [errors]="
                              frm_travel.get('price_sub_infant')?.errors
                            "></st-travel-errors>
                      }
                    </div>
                    <div class="col-6 md:col-12 xl:col-6">
                      <label>Riduzione infant (fino a 2 anni)</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price_sub_child" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price_sub_child")?.errors &&
                      frm_travel.get("price_sub_child")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price_sub_child')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div class="h-full flex flex-column justify-content-between">
                    <div>
                      <div class="section-icon img-12"></div>
                      <h3>
                        Metodo di <span class="yellow">pagamento</span> e
                        <span class="green">condizioni</span>
                      </h3>
                      <!-- <small class="grey-text">Il viaggio sarà saldabile fino a 30 giorni prima
                                                della partenza. Sia l'acconto che il saldo possono essere pagati con
                                                bonifico o tramite Stripe.</small> -->
                      <small class="grey-text">Sia l'acconto che il saldo possono essere pagati
                        tramite bonifico SEPA o Stripe. La scadenza del saldo
                        prevista in automatico dal sistema è 30 giorni prima
                        della partenza. <br /><b class="dark">Il costo del servizio (3%) può essere a carico
                          dell'organizzatore o del viaggiatore.</b></small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="grid">
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <!-- <p-inputSwitch formControlName="checkout_full_payment"
                                                    inputId="checkout_full_payment" />
                                                <label for="checkout_full_payment" class="text-sm mb-1">Pagamento
                                                    completo al checkout</label>-->
                      </div>
                      <!-- @if(frm_travel.get('checkout_full_payment')?.errors &&
                                            frm_travel.get('checkout_full_payment')?.dirty){
                                            <st-travel-errors
                                                [errors]="frm_travel.get('checkout_full_payment')?.errors"></st-travel-errors>
                                            } -->
                    </div>
                    <!-- @if(frm_travel.get('checkout_full_payment')?.value === false){ -->
                    <div class="col-6">
                      <label>Anticipo</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="checkout_advance" />
                        </p-inputGroup>
                        <!-- <st-travel-errors
                                                [errors]="frm_travel.get('checkout_advance')?.errors"></st-travel-errors> -->
                      </div>
                    </div>
                    <div class="col-6">
                      <label>Scadenza saldo</label>
                      <div>
                        <p-calendar styleClass="w-full" [showClear]="true" dateFormat="dd/mm/yy" appendTo="body"
                          [showTime]="false" [formControl]="payoff_due_date_control"></p-calendar>
                      </div>
                    </div>

                    <div class="col-12">
                      <label>Termini e condizioni</label>
                      <div class="w-full block mt-1">
                        <p-editor [style]="{ height: '120px' }" [ngClass]="{
                              'p-invalid':
                                frm_travel.get('terms_and_conds')?.invalid &&
                                frm_travel.get('terms_and_conds')?.dirty,
                            }" formControlName="terms_and_conds">
                          <ng-template pTemplate="header">
                            <span class="ql-formats">
                              <button type="button" class="ql-bold" aria-label="Bold"></button>
                              <button type="button" class="ql-italic" aria-label="Italic"></button>
                              <button type="button" class="ql-underline" aria-label="Underline"></button>
                            </span>
                          </ng-template>
                        </p-editor>
                      </div>
                      @if (
                      frm_travel.get("terms_and_conds")?.errors &&
                      frm_travel.get("terms_and_conds")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('terms_and_conds')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <div class="flex align-items-center gap-3">
                        <p-inputSwitch formControlName="customer_pays_fees" inputId="customer_pays_fees" />
                        <label for="customer_pays_fees" class="text-sm mb-1">Costi di servizio a carico del
                          viaggiatore</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
          <!-- }  -->
          <!-- @case (4) { -->
          <!-- ASSICURAZIONE ANNULLAMENTO -->
          @if (!travel_data?.funding ) {
          <div class="mb-3" [hidden]="menuIndex !== 4">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div>
                    <div class="section-icon img-15"></div>
                    <h3>Assicurazione <span class="yellow">annullamento</span></h3>
                    <small class="grey-text">Imposta l’assicurazione annullamento tra le opzioni disponibili per il
                      viaggio.</small>
                  </div>
                  @if (!cancellation_attachment) {
                  <div class="add-insurance flex align-items-center gap-1 mt-4">
                    <i class="pi pi-plus"></i>
                    <span (click)="openFileImportCancellation()">Aggiungi assicurazione annullamento</span>
                    @if (loading_cancellation_attachment) {
                    <i class="pi pi-spin pi-spinner"></i>
                    }
                  </div>
                  } @else {
                  <div class="mt-4">
                    <span class="text-sm font-medium">Assicurazione Annullamento:</span>
                  </div>
                  <div class="flex align-items-center gap-2 mt-3">
                    <img src="/assets/media/icons/pdf.png" height="32" />
                    <div class="flex flex-column gap-1">
                      <small>{{
                        cancellation_attachment.original_name
                        }}</small>
                      <small class="grey-text">{{
                        cancellation_attachment.size | bytes
                        }}</small>
                    </div>
                    <div>
                      <p-button icon="pi pi-times" (click)="removeCancellation()" [text]="true" size="small"></p-button>
                    </div>
                  </div>
                  }
                </div>
                <div class="col">
                  @if(frmInsurancesControls.length > 0){
                  <div class="grid" [formGroup]="frmInsurancesControls[0]">
                    <div class="col-12">
                      <label>Titolo</label>
                      <input type="text" pInputText class="w-full mt-1" formControlName="title" />
                      @if (
                      frm_travel.get("title")?.errors &&
                      frm_travel.get("title")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('title')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>Descrizione</label>
                      <div class="w-full block mt-1">
                        <textarea rows="5" cols="30" pInputTextarea class="w-full" formControlName="description">
                            </textarea>
                      </div>
                      @if (
                      frm_travel.get("description")?.errors &&
                      frm_travel.get("description")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('description')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>Prezzo</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price")?.errors &&
                      frm_travel.get("price")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>}
                </div>
              </div>
            </div>
          </div>
          <!-- ASSICURAZIONE medico bagaglio -->
          <div class="mb-3" [hidden]="menuIndex !== 4">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div>
                    <div class="section-icon img-16"></div>
                    <h3>Assicurazione <span class="yellow"> medico bagaglio </span></h3>
                    <small class="grey-text">Imposta l’assicurazione medico bagaglio tra le opzioni disponibili per il
                      viaggio.</small>
                  </div>
                  @if (!luggage_attachment) {
                  <div class="add-insurance flex align-items-center gap-1 mt-4">
                    <i class="pi pi-plus"></i>
                    <span (click)="openFileImportCancellation()">Aggiungi assicurazione medico‑bagaglio </span>
                    @if (loading_luggage_attachment) {
                    <i class="pi pi-spin pi-spinner"></i>
                    }
                  </div>
                  } @else {
                  <div class="mt-4">
                    <span class="text-sm font-medium">Assicurazione Annullamento:</span>
                  </div>
                  <div class="flex align-items-center gap-2 mt-3">
                    <img src="/assets/media/icons/pdf.png" height="32" />
                    <div class="flex flex-column gap-1">
                      <small>{{
                        luggage_attachment.original_name
                        }}</small>
                      <small class="grey-text">{{
                        luggage_attachment.size | bytes
                        }}</small>
                    </div>
                    <div>
                      <p-button icon="pi pi-times" (click)="removeCancellation()" [text]="true" size="small"></p-button>
                    </div>
                  </div>
                  }
                </div>
                <div class="col">
                  @if(frmInsurancesControls.length > 1){
                  <div class="grid" [formGroup]="frmInsurancesControls[1]">
                    <div class="col-12">
                      <label>Titolo</label>
                      <input type="text" pInputText class="w-full mt-1" formControlName="title" />
                      @if (
                      frm_travel.get("title")?.errors &&
                      frm_travel.get("title")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('title')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>Descrizione</label>
                      <div class="w-full block mt-1">
                        <textarea rows="5" cols="30" pInputTextarea class="w-full" formControlName="description">
                            </textarea>
                      </div>
                      @if (
                      frm_travel.get("description")?.errors &&
                      frm_travel.get("description")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('description')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>Prezzo</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price")?.errors &&
                      frm_travel.get("price")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }
          <!--SERVIZI AGGIUNTIVI-->
          <div class="mb-3" [hidden]="menuIndex !== 4">
            <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12 md:col-6 md:pr-6">
                  <div>
                    <div class="section-icon img-13"></div>
                    <h3>Servizi <span class="yellow">aggiuntivi</span></h3>
                    <small class="grey-text">Inserisci i servizi aggiuntivi del tuo viaggio che i
                      travelers possono acquistare.</small>
                  </div>

                </div>
                <div class="col">
                  @for (s of frmServiceControls; track s) {
                  @if (frmServiceControls.length > 1) {
                  <h4 class="mb-0">
                    Servizio <span class="green">{{ $index + 1 }}</span>
                    <i class="pi pi-trash ml-2 mb-3 clickable text-xs" (click)="remove($index, frmService)"></i>
                  </h4>

                  <div class="grid" [formGroup]="s">
                    <div class="col-12">
                      <label>Titolo*</label>
                      <input type="text" pInputText class="w-full mt-1" formControlName="title" />
                      @if (
                      frm_travel.get("title")?.errors &&
                      frm_travel.get("title")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('title')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>Descrizione*</label>
                      <div class="w-full block mt-1">
                        <textarea rows="5" cols="30" pInputTextarea class="w-full" formControlName="description">
                            </textarea>
                      </div>
                      @if (
                      frm_travel.get("description")?.errors &&
                      frm_travel.get("description")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('description')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>Prezzo*</label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price")?.errors &&
                      frm_travel.get("price")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                  } @else {
                  <div class="grid" [formGroup]="s">
                    <div class="col-12">
                      <label>
                        @if (
                        (s.get("title")?.touched &&
                        s.get("title")?.value) ||
                        (s.get("description")?.touched &&
                        s.get("description")?.value) ||
                        (s.get("price")?.touched && s.get("price")?.value)
                        ) {
                        <span>*</span>
                        }
                        Titolo
                      </label>

                      <input type="text" pInputText class="w-full mt-1" formControlName="title" />
                      @if (
                      frm_travel.get("title")?.errors &&
                      frm_travel.get("title")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('title')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>
                        @if (
                        (s.get("title")?.touched &&
                        s.get("title")?.value) ||
                        (s.get("description")?.touched &&
                        s.get("description")?.value) ||
                        (s.get("price")?.touched && s.get("price")?.value)
                        ) {
                        <span>*</span>
                        }
                        Descrizione
                      </label>
                      <div class="w-full block mt-1">
                        <textarea rows="5" cols="30" pInputTextarea class="w-full" formControlName="description">
                            </textarea>
                      </div>
                      @if (
                      frm_travel.get("description")?.errors &&
                      frm_travel.get("description")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('description')?.errors"></st-travel-errors>
                      }
                    </div>
                    <div class="col-12">
                      <label>
                        @if (
                        (s.get("title")?.touched &&
                        s.get("title")?.value) ||
                        (s.get("description")?.touched &&
                        s.get("description")?.value) ||
                        (s.get("price")?.touched && s.get("price")?.value)
                        ) {
                        <span>*</span>
                        }
                        Prezzo
                      </label>
                      <div class="block w-full mt-1">
                        <p-inputGroup>
                          <p-inputGroupAddon>{{
                            frm_travel.get("currency")?.value | currencyPipe
                            }}</p-inputGroupAddon>
                          <input type="number" pInputText formControlName="price" />
                        </p-inputGroup>
                      </div>
                      @if (
                      frm_travel.get("price")?.errors &&
                      frm_travel.get("price")?.dirty
                      ) {
                      <st-travel-errors [errors]="frm_travel.get('price')?.errors"></st-travel-errors>
                      }
                    </div>
                  </div>
                  }
                  }
                  @if (!travel_data?.funding ) {
                  <div class="flex out-green mt-3 justify-content-center md:justify-content-end">
                    <p-button (click)="addService()" label="Aggiungi servizio" size="small" styleClass="px-6"
                      [outlined]="true"></p-button>
                  </div>
                  } @else {
                  <!-- FINTO DISABLED PER FUNDING TRUE UI -->
                  <div class="col-12 flex flex-column justify-content-between">
                    <div
                      class="flex col out-green mt-3 justify-content-center md:justify-content-end opacity-50 pointer-events-none">
                      <p-button label="Aggiungi servizio" size="small" styleClass="px-6" [outlined]="true"></p-button>
                    </div>
                    <div class="col-12 mt-10 text-right">
                      <span class="yellow mt3 text-xs">* Potrai definire i servizi aggiuntivi in fase di
                        finalizzazione</span>
                    </div>
                  </div>
                  }
                  <!-- FINTO DISABLED PER FUNDING TRUE UI -->
                </div>
              </div>
            </div>
          </div>
          <!-- } -->
          <!-- } -->
          <div class="flex align-items-center justify-content-between my-5">
            <div class="flex align-items-center gap-2 clickable" (click)="goBack()"
              [ngClass]="{ disabled: menuIndex === 0 }">
              <i class="pi pi-angle-left"></i>
              <small>Indietro</small>
            </div>
            <div class="flex align-items-center gap-2 clickable" (click)="goFurther()"
              [ngClass]="{ disabled: menuIndex === 4 }">
              <small>Avanti</small>
              <i class="pi pi-angle-right clickable"></i>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<p-dialog [closable]="false" header="" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="body">
    <div class="text" style="max-height: 60vh; overflow-y: auto;" (scroll)="onTcScroll($event)">
      <section class="terms">
        <h2 class="yellow text-center">Cos'è un evento GMG</h2>
        <p>
          "Crea un evento GMG" ti consente di creare una proposta di viaggio per la
          <strong class="green">Giornata Mondiale della Gioventù</strong>, che si terrà a
          <strong>Seul dal 3 all'8 Agosto 2027</strong>.
        </p>
        <p>
          In fase di creazione, ti basterà inserire poche semplici informazioni per condividere la proposta con i
          tuoi contatti e iniziare a raccogliere <strong>adesioni</strong> da potenziali
          partecipanti e <strong>donazioni</strong> da chi desidera contribuire alla realizzazione
          del viaggio. Questo ti aiuterà a capire quanti potrebbero essere gli interessati e quale prezzo
          applicare, così da definire il programma di viaggio più adatto.
        </p>
        <p>
          La tua proposta sarà <strong>sempre modificabile</strong>: potrai arricchirla, aggiornarla e
          perfezionarla in ogni momento. Quando sarai pronto, potrai finalizzarla aggiungendo i dettagli
          definitivi, come date di partenza e rientro, voli, pacchetti di viaggio e quote di partecipazione.
          Hai tempo fino al <strong>30/11/2026</strong> per completare questa fase.
        </p>
        <p>
          Completata la finalizzazione, chi aveva già espresso interesse riceverà una notifica e potrà confermare
          la partecipazione entro <strong>10 giorni</strong>. Potrai inoltre invitare altri
          contatti a unirsi al viaggio. Se desideri raggiungere una platea ancora più ampia, potrai scegliere di
          rendere il viaggio <strong>"Pubblico"</strong>, rendendolo visibile all'intera community
          Social Travels, che potrà decidere se partecipare.
        </p>
        <p>
          Crea la tua proposta e inizia a costruire un'esperienza capace di lasciare il segno.
        </p>

        <hr />

        <h2 class="yellow text-center">Termini e Condizioni</h2>
        <h3>ACCORDO TRA</h3>
        <p>
          - la IMPRONTE VIAGGI E TURISMO Srl, con sede legale in Roma, Via Santa Croce in Gerusalemme, 77, C.F. e
          P.IVA 01462841006, iscritta al Registro delle Imprese presso la CCIAA di Roma al n.05900480582, Pec:
          impronteviaggi&#64;mypec.eu, in persona del legale rappresentante pro-tempore Sig. Massimo Bellucci (di
          seguito "Incaricato");
        </p>
        <p>E</p>
        <p>- l'Utente di questa Applicazione (di seguito "Committente").</p>

        <h3>PREMESSO</h3>
        <p>
          che il Committente è impegnato a raccogliere adesioni di persone che desiderano partecipare alla
          prossima Giornata Mondiale della Gioventù (di seguito GMG) che si svolgerà in Corea del Sud, nella città
          di Seul nel 2027;
        </p>
        <p>
          che il Committente ha intenzione, una volta formati i gruppi di partecipanti alla GMG (di seguito "I
          Gruppi"), di commissionare l'organizzazione di pacchetti di viaggio per tali gruppi ad una impresa
          specializzata nel settore;
        </p>
        <p>
          che Impronte Viaggi e Turismo è un'Agenzia di Viaggi specializzata nell'organizzazione di viaggi
          religiosi e pellegrinaggi e da anni è fiduciaria di numerosi Enti, Associazioni ed Autorità religiose;
        </p>
        <p>
          che il Committente ha quindi interesse ad individuare un soggetto fiduciario cui poter far riferimento
          ai fini di organizzare i detti pacchetti di viaggio per la partecipazione alla GMG a favore dei Gruppi di
          partecipanti che aderiranno all'iniziativa;
        </p>
        <p>
          che Impronte Viaggi si è resa disponibile a mettere a disposizione la propria esperienza ed
          organizzazione nel campo del turismo religioso e la propria programmazione di viaggi e soggiorni per
          soddisfare le esigenze del Committente;
        </p>
        <p>tutto quanto sopra premesso, le parti convengono e stipulano quanto segue:</p>

        <h3>Art. 1 – OGGETTO / INCARICO IN ESCLUSIVA</h3>
        <p>
          Il Committente individua in esclusiva la Impronte Viaggi e Turismo Srl quale partner fiduciario per
          l'organizzazione, a beneficio dei partecipanti i propri Gruppi, dei pacchetti di viaggio per la
          partecipazione alla GMG 2027.
        </p>
        <p>
          Impronte Viaggi e Turismo, a seguito dell'incarico sopra detto, si impegna ad ideare e progettare il
          programma/itinerario ed i contenuti dei pacchetti turistici, individuando idonei fornitori dei servizi
          turistici (es. vettori, strutture ricettive, trasfert), servizi di supporto, assicurazioni accessorie al
          viaggio e quant'altro necessario per soddisfare le esigenze del Gruppo, al fine di pervenire alla
          quotazione del relativo prezzo del pacchetto.
        </p>
        <p>
          Nell'esecuzione dell'incarico Impronte Viaggi e Turismo garantirà la necessaria diligenza e
          professionalità.
        </p>
        <p>
          I pacchetti turistici, una volta definiti nel loro contenuto, saranno formalmente contrattualizzati ai
          sensi della normativa di riferimento (art. 32 e seguenti del Codice del Turismo – Dlgs 79/2011)
          direttamente con i singoli partecipanti al Gruppo ovvero dal Committente o da un Capo Gruppo in
          rappresentanza di tutti i partecipanti (verrà allegata lista partecipanti), valendo il contratto di
          pacchetto quale contratto a beneficio del terzo ex art. 1411 c.c. e seguenti.
        </p>

        <h3>Art. 2 – RACCOLTA DELLE ADESIONI - VERSAMENTI</h3>
        <p>
          Il Committente si obbliga a pubblicizzare presso la propria utenza, nell'ambito di tutti i suoi canali
          di comunicazione ed informazione, l'opportunità di partecipare alla GMG 2027, tramite il pacchetto di
          viaggio organizzato dal proprio fiduciario Impronte Viaggi proposte di viaggio.
        </p>
        <p>
          All'uopo metterà a disposizione i propri gli Uffici di Segreteria e amministrativi per la raccolta dei
          nominativi dei soggetti interessati, che saranno trasmessi all'Incaricato, secondo tempistiche e
          modalità concordate tra le parti.
        </p>
        <p>
          Poiché la quotazione e determinazione del prezzo del pacchetto pro-capite sarà frutto di un complesso
          lavoro legato alla ricerca delle migliori soluzioni di fornitura dei servizi, alla acquisizione del
          numero complessivo dei partecipanti, il Committente prende atto e concorda che l'Incaricato dovrà
          assumere impegni con i fornitori dei servizi già nella fase di costruzione del pacchetto, sottoscrivendo
          opzioni impegnative a titolo oneroso, tariffe non rimborsabili e sostenendo costi di lavorazione
          dell'operazione. Conseguentemente la Committente si impegna a raccogliere dai partecipanti al Gruppo ed a
          far versare somme in acconto sul prezzo del pacchetto, secondo quanto richiesto dall'Incaricato ed entro
          le tempistiche dallo stesso richieste.
        </p>
        <p>
          Resta inteso che, ove il Committente, entro e non oltre la data dell'11 Dicembre 2026, dovesse comunicare
          che il Gruppo o alcuni partecipanti ad esso, intendono rinunciare al viaggio, le dette somme versate in
          acconto saranno restituite entro e non oltre 14 giorni dalla comunicazione, ad eccezione delle sole
          spese di apertura pratica che saranno calcolate in una percentuale del 3%.
        </p>
        <p>
          Il Committente assicura anche ogni utile collaborazione per sollecitare i partecipanti ai propri Gruppi
          ad adempiere alle richieste ed obbligazioni contrattuali nei confronti dell'Incaricato.
        </p>

        <h3>Art. 3 – SEGNI DISTINTIVI – LOGHI E MARCHI</h3>
        <p>
          Le parti si autorizzano reciprocamente a poter utilizzare, nell'ambito dell'esecuzione del presente
          accordo, i loro segni distintivi, loghi e marchi, anche con la finalità di poter aumentare all'esterno e
          verso terzi la visibilità della loro collaborazione.
        </p>
        <p>
          Impronte Viaggi potrà utilizzare la dicitura "Organizzatore di viaggio fiduciario di - l'Utente - per la
          GMG 2027" ed il Committente potrà utilizzare la dicitura "Viaggio GMG 2027 organizzato da Impronte Viaggi
          per - l'Utente -".
        </p>

        <h3>Art. 4 – SERVIZI DI SUPPORTO E CONSULENZA</h3>
        <p>
          Nell'ambito della presente collaborazione, Impronte Viaggi e Turismo si impegna a fornire, tramite la
          propria organizzazione, il servizio di informazione, assistenza e consulenza al Committente ed ai
          partecipanti ai Gruppi per la migliore illustrazione del programma di viaggio e per ogni altra
          problematica inerente, al fine di prestare il miglior servizio e supporto per la pianificazione e
          realizzazione del viaggio.
        </p>

        <h3>Art. 6 – ESECUZIONE DELLA COLLABORAZIONE</h3>
        <p>
          Le parti si impegnano ad eseguire il presente contratto secondo i principi di correttezza e buona fede
          ai sensi dell'art. 1375 cc.
        </p>

        <h3>Art. 7 – MODIFICHE</h3>
        <p>
          Tutte le modifiche al presente accordo saranno consentite solo previo accordo scritto stipulato tra le
          parti.
        </p>

        <h3>Art. 8 – DURATA – TACITO RINNOVO</h3>
        <p>
          Il presente accordo avrà durata dalla data di sottoscrizione, fino al rientro dei viaggiatori,
          componenti dei Gruppi, dalla GMG 2027.
        </p>

        <h3>Art. 9 – ELEZIONE DI DOMICILIO – FORMA DELLE COMUNICAZIONI</h3>
        <p>Le parti eleggono domicilio ai fini del presente atto come segue:</p>
        <p>- Impronte Viaggi e Turismo Srl, presso il proprio domicilio digitale PEC: impronteviaggi&#64;mypec.eu;</p>
        <p>- il Committente, presso il proprio domicilio digitale PEC.</p>
        <p>
          Tutte le comunicazioni, ad eccezione di quelle ordinarie e meramente esecutive, inerenti il presente
          accordo, dovranno essere inviate, al domicilio eletto delle parti, come sopra indicato.
        </p>

        <h3>Art. 10 – FORO COMPETENTE</h3>
        <p>
          Per ogni controversia derivante dall'interpretazione ed esecuzione del presente accordo, sarà competente
          in via esclusiva il Foro di Roma.
        </p>
      </section>
    </div>
    <div class="flex align-items-center gap-2 mt-3">
      <p-checkbox [binary]="true" [formControl]="tcAccept" inputId="acceptTcGmg" />
      <label for="acceptTcGmg">Ho letto e accetto i Termini e Condizioni</label>
      @if (!tcScrolledToEnd) {
      <small class="grey-text">(scorri fino in fondo per poter accettare)</small>
      }
    </div>
    <div class="modal-footer flex justify-content-between gap-3 mt-3">
      <p-button label="Annulla" class="flex-grow-1 out-green" styleClass="w-full" (click)="visible = false"
        [outlined]="true" routerLink="/"></p-button>

      <p-button class="flex-grow-1" label="Crea" (click)="visible = false" styleClass="slide w-full"
        [disabled]="!tcAccept.value"></p-button>
    </div>
  </ng-template>
</p-dialog>



<!--  CDKDROPLIST -->
<!-- <div class="form-section mb-4">
              <div class="grid">
                <div class="col-12">
                  <div class="section-icon img-9"></div>
                  <h3>Immagini e <span class="yellow">video</span></h3>
                  <small class="grey-text">Carica la foto dei paesi che tu e i travelers andrete a
                    visitare. Puoi anche inserire il link di un video Youtube
                    per promuovere o preparare i travelers al viaggio.</small>
                  <div
                    class="flex align-items-center justify-content-center md:justify-content-start gap-3 mt-5 flex-wrap">
                    @if (travel_img && travel_img.length > 0) {

                    <span class="yellow mt3 text-xs">Puoi riordinare le immagini trascinandole nella posizione che
                      preferisci.</span>

                    <div cdkDropList cdkDropListOrientation="horizontal" class="cdkDrop-list"
                      (cdkDropListDropped)="drop($event)">


                      @for (img of travel_img; let index = $index; track img.media.id) {

                      <div class="cdkDrop-box travel-placeholder img" cdkDrag> <img [src]="
                              travel_img![$index].media
                                | imagePipe: 'user' : 'lg'
                            " />
                        <div class="delete-img">
                          <i class="pi pi-trash" (click)="
                                deleteImg(travel_img![$index].media.id, $index)
                              "></i>
                        </div>
                      </div>

                      }
                    </div>
                    } @else {
                    <div class="travel-placeholder">
                      <img src="/assets/media/icons/photos.png" width="60" />
                    </div>
                    }
                    @if (travel_img && travel_img!.length > 0) {
                    <div
                      class="add-travel-img flex align-items-center justify-content-center md:justify-content-start gap-2">
                      @if (imgLoading) {
                      <i class="pi pi-spin pi-spinner"></i>
                      } @else {
                      <i class="pi pi-plus link-o green" (click)="openTravelImagePicker()" pTooltip="Carica foto"
                        tooltipPosition="top"></i>
                      <i class="pi pi-search link-o green" (click)="openCloudImagePickerModal()" pTooltip="Cerca foto"
                        tooltipPosition="top"></i>
                      }
                    </div>
                    } @else {
                    @if (imgLoading) {
                    <i class="pi pi-spin pi-spinner"></i>
                    } @else {
                    <div class="flex align-items-center gap-1">
                      <span class="link-o green" (click)="openTravelImagePicker()">Carica una foto</span>
                      <span class="grey-text">oppure</span>
                      <span class="link-o green" (click)="openCloudImagePickerModal()">cerca una foto nel cloud</span>
                    </div>
                    }
                    }
                  </div>
                </div>
                <div class="col-12">
                  <label>URL Youtube</label>
                  <div class="w-full block mt-1">
                    <input type="text" formControlName="youtube_url" pInputText class="w-full mt-1" />
                  </div>
                </div>
              </div>
            </div> -->